export function originParamsFromUser(user) {
  const address = user?.default_address;

  if (address?.latitude == null || address?.longitude == null) {
    return {};
  }

  return {
    origin_lat: address.latitude,
    origin_lng: address.longitude,
  };
}
